import { lazy } from 'react'

export const ReleaseListPage = lazy(() => import('./ReleaseListPage'))
